import { connect, mapReadPretty } from '@formily/react'
import { Input } from 'antd'

import { Password as CommonPassword } from '@eastcoal/common/components/Password'

export const Password = connect(
  CommonPassword,
  mapReadPretty(Input, {
    disabled: true,
    type: 'password'
  })
)
